import { NavigationCarat } from '../assets/svgImages';
import { BreadcrumsProps } from '../interface/interface';

const Breadcrumbs = (props: Readonly<BreadcrumsProps>) => {
  return (
    <nav className={`flex mb-3`} aria-label="Breadcrumb">
      <ol className="inline-flex items-center flex-wrap">
        {props?.data?.map((e, index) => (
          <li
            key={index}
            className="flex items-center text-sm text-primary-blue-500"
          >
            {index > 0 && (
              <span className={`${props?.hasBanner ? 'mt-8 md:mt-0' : ''} `}>
                <NavigationCarat />
              </span>
            )}
            <e.tag
              className={`${e?.className ?? ''} inline-flex items-center whitespace-nowrap ${e.href ? 'font-semibold underline' : 'font-normal'}`}
              {...(e.href ? { href: e.href } : {})}
            >
              {e.children}
            </e.tag>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
